var _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQtIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4482 19.5957C46.4655 25.7575 44.727 34.0093 38.5652 38.0265L23.1788 48.0579C19.1616 41.896 20.9001 33.6443 27.0619 29.627L42.4482 19.5957Z",
    fill: "#FF6600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.1748C7.27468 15.0861 14.0545 20.1009 15.1432 27.3755L17.8617 45.5408C10.587 46.6295 3.80718 41.6148 2.7185 34.3401L0 16.1748Z",
    fill: "#FF6600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09375 11.2271C9.05082 5.02642 17.2853 3.20765 23.4859 7.16472L38.9692 17.0457C35.0122 23.2464 26.7777 25.0651 20.5771 21.1081L5.09375 11.2271Z",
    fill: "#002366"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.9613,
    cy: 19.2577,
    r: 5.06779,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQtIcon);
export default __webpack_public_path__ + "static/media/qtIcon.f2bcae6e9226d821eea6528d480c5c12.svg";
export { ForwardRef as ReactComponent };